import React from 'react';

const SpecialistItem = ({ name, position, available, price, duration, image, onClick, needsRegistration }) => {
  return (
    <div className="flex items-center bg-white rounded-lg shadow p-4">
      <img src={image} alt={name} className="w-16 h-16 rounded-full object-cover mr-4" />
      <div className="flex-1">
        <h3 className="font-bold">{name}</h3>
        <p className="text-gray-500">{position}</p>
        {available && (
          <div className="flex items-center mt-1">
            <div className="w-2 h-2 rounded-full bg-green-500 mr-2"></div>
            <span className="text-gray-600 text-sm">Disponibil</span>
          </div>
        )}
        {price && <div className="text-sm text-gray-600 mt-1">{duration}, {price}</div>}
      </div>
      {needsRegistration ? (
        <button className="bg-gray-200 text-blue-600 py-2 px-4 rounded-full">
          Înscrie-te
        </button>
      ) : (
        <button 
          className="bg-blue-600 text-white py-2 px-4 rounded-full"
          onClick={onClick}
        >
          Alege
        </button>
      )}
    </div>
  );
};

export default SpecialistItem;